import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import useLookUpBase from "../../components/selectbox/LookupBase";
import { FileUploader, Gallery, ScrollView } from "devextreme-react";
import { Popup } from "devextreme-react/popup";
import Guid from "../../models/Guid";
import Form, { ButtonItem, GroupItem, Label, SimpleItem } from "devextreme-react/form";
import Webcam from "react-webcam";
import './popup-photo.css';

interface IPopupProps {
  idUnite: Guid,
  togglePopup: (e: boolean) => void,
  onValueChanged: () => void,
  isModeModifier: boolean
}
const PopupPhoto = ({ togglePopup, idUnite, onValueChanged, isModeModifier }: IPopupProps) => {
  const { currentSelectedItem, editorOptions: messagesEditorOption, selectBox: MessagesSelectBox } = useLookUpBase({ controllerName: "message", setDataRow: () => setDataRow("idMessage"), path: "lookup/c", showFind: false, showClear: isModeModifier });
  const [copie, setCopie] = useState("");
  const [photo, setPhoto] = useState("");
  const [webcamActif, setWebcamActif] = useState(false);
  const webcamRef = useRef<Webcam>(null);
  // const [imgSrc, setImgSrc] = useState<string | null>(null);
  const [dernierePrise, setDernierePrise] = useState("");

  const capture = useCallback(() => {
    if (webcamRef?.current) {
      const imageSrc = webcamRef.current.getScreenshot()?.toString();
      if (imageSrc) {
        setPhoto(imageSrc)
        setDernierePrise(getCurrentDateTime());
      }
    }
  }, [webcamRef]);

  const CustomWebcam = () => {
    return (
      <div className="container">
        {/* {imgSrc ? (
          <img src={imgSrc} alt="webcam" />
        ) : ( */}
        <Webcam height={300} width={300} ref={webcamRef} />
        {/* )} */}
        {/* <div className="btn-container">
          <button onClick={capture}>Capture photo</button>
        </div> */}
      </div>
    );
  };

  const prendrePhotoOptions = useMemo(() => {
    return {
      text: "Prendre une photo",
      width: "max-content",
      horizontalAlignment: "center",
      verticalAlignment: 'center',
      onClick: capture
    };
  }, []);

  const recadrerPhotoOptions = useMemo(() => {
    return {
      text: "Recadrer la photo",
      disabled: true,
      onClick: () => { }
    };
  }, []);

  const effacerPhotoOptions = useMemo(() => {
    return {
      text: "X",
      onClick: () => {
        setPhoto("");
      }
    };
  }, []);

  const demarerApercuOptions = useMemo(() => {
    return {
      text: "Démarrer l'aperçu",
      onClick: () => setWebcamActif(true)
    };
  }, [webcamRef]);

  const confirmBtn = useMemo(() => {
    return {
      text: "OK",
      onClick: () => {
      }
    };
  }, []);

  const annulerBtn = useMemo(() => {
    return {
      width: '130px',
      text: "Annuler",
      onClick: () => { togglePopup(false); }
    };
  }, []);

  const getCurrentDateTime = (): string => {
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = currentDate.getFullYear();
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };


  // https://blog.logrocket.com/using-react-webcam-capture-display-images/

  return <Popup
    visible={true}
    // visible={this.state.popupVisible}
    // onHiding={this.hideInfo}
    dragEnabled={true}
    resizeEnabled={true}
    hideOnOutsideClick={false}
    showCloseButton={true}
    showTitle={true}
    dragOutsideBoundary={true}
    title="Prise de photo"
    container=".dx-viewport"
    width={1000}
    height={455}
  >
    <ScrollView width='100%' height='100%' id='popup-courriel'>
      <div style={{ display: "flex" }}>
        <div style={{ width: "100%" }}>
          <Form readOnly={false} alignItemLabelsInAllGroups={true}
            className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
            <GroupItem colCount={3}>
              <GroupItem>
                <GroupItem>
                  <Label text='Aperçu' />
                  <ButtonItem buttonOptions={demarerApercuOptions} />
                </GroupItem>
                <GroupItem>
                  {webcamActif
                    ? <CustomWebcam />
                    : <Gallery
                      className='popup-photo-gallery'
                      // dataSource={[`data:image/png;base64,${imgSrc}`]}
                      noDataText=''
                      width={300}
                      height={300}
                      showIndicator={false}
                    />
                  }


                </GroupItem>
              </GroupItem>
              <GroupItem cssClass='popup-photo-centered-div'>
                <ButtonItem buttonOptions={prendrePhotoOptions} />
                <SimpleItem>
                  <Label text='Dernière prise' />
                </SimpleItem>
                <SimpleItem>
                  <Label text={dernierePrise} />
                </SimpleItem>
                <ButtonItem buttonOptions={recadrerPhotoOptions} />
              </GroupItem>
              <GroupItem colSpan={2}>
                {/* <GroupItem colCount={3}> */}
                <GroupItem>
                  <GroupItem colCount={3}>
                    <SimpleItem>
                      <Label text='Photo du client' />
                    </SimpleItem>
                    <SimpleItem>
                      <FileUploader
                        width={"max-content"}
                        onValueChange={async (e) => {
                          if (e?.[0]) {
                            // if (e.value?.[0]) {
                            const file = e[0];
                            const fr = new FileReader();
                            await fr.readAsDataURL(file);
                            fr.onload = () => {
                              if (fr.result) {
                                const base64 = fr.result.toString();
                                // const base64 = fr.result?.toString()?.split(',')[1];
                                if (base64)
                                  setPhoto(base64)
                              }
                            };
                          } else {
                            alert("File not selected or browser incompatible.")
                          }
                        }}
                        showFileList={false}
                        // selectButtonText="…"
                        selectButtonText="Importer…"
                        labelText="" accept="image/*" uploadMode="useForm"
                      />
                    </SimpleItem>
                    <ButtonItem buttonOptions={effacerPhotoOptions} />
                  </GroupItem>

                </GroupItem>
                <GroupItem>
                  <Gallery
                    className='popup-photo-gallery'
                    dataSource={[`${photo}`]}
                    // dataSource={[`data:image/png;base64,${photo}`]}
                    noDataText='Pas de données image'
                    width={300}
                    height={300}
                    showIndicator={false}
                  />
                </GroupItem>
              </GroupItem>
            </GroupItem>
            <GroupItem colCount={2} cssClass='alignRight'>
              <ButtonItem buttonOptions={confirmBtn} />
              <ButtonItem buttonOptions={annulerBtn} />
            </GroupItem>
          </Form>
        </div>
      </div>
    </ScrollView>
  </Popup>
}

export default PopupPhoto;

function setDataRow(arg0: string) {
  throw new Error('Function not implemented.');
}
